import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { SellerOrganizationInfoService } from 'common/data';

class SellerOrganizationInfoStore extends BaseStore {
	constructor(rootStore) {
		super(new SellerOrganizationInfoService(rootStore.app.baasic.apiClient));
	}

	@action async updateSellerOrganizationInfo(sellerOrganizationInfo, sourceOfChange) {
		await this.service.update(sellerOrganizationInfo, sourceOfChange);
	}
}

export default SellerOrganizationInfoStore;
